import { useContext, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import _map from 'lodash/map';

import { AppContext } from 'commons-ui';
import useService from '../../utils/useService';
import { FORM_FIELD_CONFIG, FORM_FIELD_KEYS } from './formConfig';

const useFixBucket = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);
	const history = useHistory();
	const location = useLocation();
	const { requestFixUserBucket } = useService();
	const data = _get(location, ['state', 'rowData']);
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.bucket].setRenderProps({
		options: _map(data.buckets, (bucket) => ({ id: bucket.id, label: bucket.name }))
	});

	const handleFormSubmit = (submittedData: any) => {
		setShowLoader(true);
		requestFixUserBucket({ userId: submittedData.userId, bucketId: submittedData.bucket, name: data.name }).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(res?.data?.error || res?.data?.externalMessage || 'Error occured while fixing users bucket', {
						type: 'error'
					});
					setShowLoader(false);
					return;
				}
				showAlert('Users bucket fixed');
				setShowLoader(false);
				history.goBack();
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.externalMessage || err.response.data.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return {
		data,
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useFixBucket;
